export const cashInCashOutTypes = {
  BANK_ACCOUNT_TYPE: "bank-account",
  SAVINGS_BANK_ACCOUNT_TYPE: "saving-bank-account",
  FLYWIRE: "flywire",
};
